module.exports = __webpack_public_path__ + "static/media/hamMenuInactive.f3aa732e.svg";